import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../../api/api';
import CampaignCard from '../campaigns/CampaignCard';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const CampaignHighlight = () => {
  const { t } = useTranslation();
  const [campaigns, setCampaigns] = useState([]);
  const titleRef = useScrollReveal();

  useEffect(() => {
    api.getCampaigns()
      .then((data) => {
        const processedData = [...data]
          .sort((a, b) => a.id - b.id)
          .slice(1);

        setCampaigns(processedData);
      })
      .catch(console.error);
  }, []);

  return (
    <section id="campaigns" className="campaigns">
      <div className="container">
        <h2
          ref={titleRef}
          className="section-title scroll-reveal"
        >
          {t('home.campaignsHighlight')}
        </h2>

        <div id="campaignsContainer">
          {campaigns.slice(0, 3).map((campaign, index) => (
            <CampaignCard
              key={campaign.id}
              campaign={campaign}
              index={index}
            />
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/campaigns" className="cta-button">
            {t('home.viewAllCampaigns')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CampaignHighlight;